export const da = {
  // Certificate Headers
  congrats_message: "Din WiFi-installation er færdig og er blevet certificeret af RouteThis!",
  installation_details: "Installationsdetaljer",
  wireless_speed_test: "Trådløs hastighedstest",
  wireless_performance: "Wireless Performance",
  photos: "Fotos",
  signal_maps: "Signalkort",
  wifi_information: 'WiFi Information',

  // Certificate Room Names
  singular_room: "Rum",
  room_type_bathroom: "Badeværelse",
  room_type_bedroom: "Soveværelse",
  room_type_dining_room: "Spisestue",
  room_type_entry_or_hall: "Entre/hal",
  room_type_garage: "Garage",
  room_type_kitchen: "Køkken",
  room_type_living_room: "Stue",
  room_type_office: "Kontor",
  room_type_other: "Andet",

  // Pod Name
  pod_1: "Mesh Pod",
  pod_2: "Adgangspunkt",
  pod_3: "Mesh node",
  pod_4: "Mesh Puck",
  pod_5: "Beacon",
  pod_6: "Mesh Pod",
  pods_1: "Mesh Pods",
  pods_2: "Adgangspunkter",
  pods_3: "Mesh nodes",
  pods_4: "Mesh Pucks",
  pods_5: "Beaconer",
  pods_6: "Mesh Pods",

  // Router Name
  router_1: "Router",
  router_2: "Modem",
  router_3: "Gateway",
  router_4: "Hub",
  router_5: "Router",

  // Level Name
  level_1: "Niveau",
  level_2: "Etage",
  levels_1: "Niveauer",
  levels_2: "Etager",

  // Certificate Pod Info
  recommended: "Anbefales",
  installed: "Installeret",
  total: "Total",

  // Certificate Signal Table
  front_building: "Forsiden af ​​Bygningen",
  speed: "Hastighed",
  video: "Video",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Link",
  frequency_short: "Frekv.",
  frequency_description: "MHz",
  channel_short: "Kan.",

  // Certificate Legend
  legend: "Forklaring",
  measured_speed: "Målt hastighed",
  measured_speed_description: "Mbps",

  // Certificate Speedtest Result
  speedtest_passed: "Hastigheden er inden for det forventede interval for de fleste mobile enheder. Ikke alle trådløse enheder er i stand til at nå maksimal planhastighed. Se nedenfor for individuelle rumtests.",
  speedtest_failed: "Testet på en telefon eller tablet. Ikke alle trådløse enheder er i stand til at nå maksimal planhastighed. Se nedenfor for individuelle rumtests.",
}